var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',{class:['scrollable-content', (_vm.removeTopMargin) ? 'nav-not-fixed' : ''],attrs:{"id":"main"}},[_c('Navbar',{attrs:{"fixed":_vm.navBarFix}}),_c('router-view'),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }